if (typeof L !== 'undefined') {
    require('./torque');
}



//////////////////
// WEBPACK FOOTER
// ./~/torque.js/lib/torque/leaflet/index.js
// module id = 1736
// module chunks = 6